/** * 首页内容 **/

<template>
  <div>
    <div class="h-div-content">
      <!-- <div id="container" style="height: 100vh"></div> -->
      <!-- 弹窗内容 -->
      <div ref="Popup" v-show="infoWindow" class="marker-content-div">
        <!-- <video
          v-if="videoShow"
          :autoplay="true"
          muted
          :src="videosrc"
          name="media"
          style="width: 98%; height: 90%"
        ></video> -->
        <assembly-flv
          v-if="videoShow"
          :url="videosrc"
          style="width: 98%; height: 90%"
        ></assembly-flv>
        <div
          v-if="!videoShow"
          v-loading="infoWindowloading"
          style="min-width: 320px; min-height: 260px"
        >
          <img
            @dblclick="
              $store.commit(
                'set_dbClickImg',
                infoWindowContent.storageUrl1 || '../../static/img/noData.jpg'
              )
            "
            style="width: 100%; max-height: 310px !important"
            :src="
              infoWindowContent.thumbnailUrl ||
                infoWindowContent.storageUrl1 ||
                '../../static/img/noData.jpg'
            "
          />
          <div v-if="infoWindowContent.name">
            姓名：{{ infoWindowContent.name || "暂无" }}
          </div>
          <div v-if="infoWindowContent.age">
            性别：{{ infoWindowContent.sex || "暂无" }}
          </div>
          <div v-if="infoWindowContent.age">
            年龄：{{ infoWindowContent.age || "暂无" }}
          </div>
          <div v-if="infoWindowContent.departmentName">
            部门：{{ infoWindowContent.departmentName || "暂无" }}
          </div>
          <div v-if="infoWindowContent.plateNo">
            车牌号码：{{ infoWindowContent.plateNo || "暂无" }}
          </div>
          <div v-if="infoWindowContent.plateNo">
            经过时间：{{ infoWindowContent.passingTimeFormat || "暂无" }}
          </div>
          <div v-if="infoWindowContent.deviceName">
            地点：{{ infoWindowContent.deviceName || "暂无" }}
          </div>
        </div>
      </div>
      <!-- 弹窗内容 -->
      <div class="u-flexwrap main-div" style="width: 100%">
        <div class="left-div">
          <!-- <div class="left-top-div">
            <div class="title">
              <i class="iconfont icon-baojingalarm8"></i>报警信息
            </div>
            <div class="content-list">
              <div
                v-for="(item1, index1) in warningInfoList"
                :key="index1"
                class="list"
              >
                <div>
                  <div class="fl">布控标题：{{ item1.title }}</div>
                  <div class="fr">{{ item1.notificationTimeFormat }}</div>
                  <div style="clear: both"></div>
                </div>
                <div>
                  设备位置：<span class="u-font-sm">{{
                    item1.deviceName
                  }}</span>
                </div>
              </div>
            </div>
          </div> -->

          <div class="left-center-div">
            <div class="title">
              <i class="el-icon el-icon-s-data"></i>车辆和人员流量统计
            </div>
            <div id="my-chart"></div>
          </div>

          <!-- 车辆和人员检索列表 -->
          <div class="left-bottom-div">
            <div class="title d-tabs">
              <i class="iconfont icon-xinxi"></i>
              <span
                v-for="(item, index) in tabList"
                :key="item"
                @click="setIndex(index)"
                :class="[index === tabscurrent ? 'active' : '']"
                >{{ item }}</span
              >
            </div>
            <!-- 为了自适应flex布局车辆信息分为两块 -->
            <div
              v-if="tabscurrent == 0"
              style="
                height: 60px;
                padding: 18px 10px 0;
                border-bottom: 1px #016ae0 dashed;
              "
            >
              <el-form
                :inline="true"
                :model="form"
                :size="'small'"
                class="demo-form-inline"
              >
                <!-- <el-form-item label="车辆颜色">
                  <el-select
                    clearable
                    style="width: 76px"
                    v-model="form.vehicleColor"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item6, key6) in $store.state.dictionary
                        .VEHICLECOLOR"
                      :key="key6"
                      :label="item6.name"
                      :value="item6.code"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="车牌号码">
                  <el-input
                    style="width: 120px"
                    v-model="form.plateNo"
                    placeholder="请输入"
                    @clear="onSubmit('clearplate')"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-button :size="'small'" type="primary" @click="onSubmit(1)"
                  >查询</el-button
                >
              </el-form>
            </div>
            <div
              v-if="tabscurrent == 0"
              class="content-list"
              style="padding-top: 0px"
            >
              <template v-if="motorvehicleList.length">
                <div
                  class="list"
                  v-for="(motorvehicleItem,
                  motorvehicleKey) in motorvehicleList"
                  :key="motorvehicleKey"
                >
                  <div style="display: flex">
                    <div
                      style="width: 30%; padding-top: 0; padding-right: 10px"
                    >
                      <img
                        @dblclick="setBig(motorvehicleItem.storageUrl1)"
                        style="width: 100%; height: 90px"
                        :src="
                          motorvehicleItem.thumbnailUrl ||
                            '/static/img/img_error2.png'
                        "
                      />
                    </div>

                    <div style="width: 70%">
                      <p>{{ motorvehicleItem.plateNo }}</p>
                      <p>
                        {{ motorvehicleItem.carFrom
                        }}<el-button
                          class="fr"
                          @click="carimgShow(motorvehicleItem)"
                          type="primary"
                          size="mini"
                          >详情</el-button
                        >
                      </p>
                      <p>{{ motorvehicleItem.passingTimeFormat.replace("T"," ") }}</p>
                      <el-tooltip
                        :content="motorvehicleItem.deviceName"
                        placement="top"
                        effect="light"
                      >
                        <a
                          href="javascript:;"
                          style="width: 100%"
                          class="text_overflow"
                          >{{ motorvehicleItem.deviceName }}</a
                        >
                      </el-tooltip>
                    </div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </template>
              <div
                v-else
                v-loading="loading"
                class="u-w-100 u-h-100 u-myflex u-a-center u-j-center"
              >
                <span class="u-tips-color">{{
                  loading ? "" : "没有数据"
                }}</span>
              </div>
            </div>
            <!-- 为了自适应flex布局车辆信息分为两块结束 -->
            <div
              v-if="tabscurrent == 1"
              style="
                height: 60px;
                padding: 18px 10px 0;
                border-bottom: 1px #016ae0 dashed;
              "
            >
              <el-form
                :inline="true"
                :model="form"
                :size="'small'"
                class="demo-form-inline"
              >
                <el-form-item label="姓名">
                  <el-input
                    style="width: 120px"
                    v-model="form.name"
                    placeholder="请输入"
                    @clear="onSubmit('clearname')"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-button :size="'small'" type="primary" @click="onSubmit(2)"
                  >查询</el-button
                >
              </el-form>
            </div>
            <div class="content-list" v-if="tabscurrent == 1">
              <div
                class="list"
                v-for="(facePageItem, facePageKey) in facePageList"
                :key="facePageKey"
              >
                <div style="display: flex">
                  <div style="width: 30%; padding-right: 10px">
                    <img
                      @dblclick="setBig(facePageItem.storageUrl1)"
                      style="width: 100%; height: 90px"
                      :src="
                        facePageItem.thumbnailUrl ||
                          facePageItem.storageUrl1 ||
                          '/static/img/img_error2.png'
                      "
                    />
                  </div>

                  <div style="width: 70%">
                    <!-- <p>
                      <span>{{ facePageItem.idcard }}</span
                      ><span class="u-m5-l-2">{{ facePageItem.sex }}</span>
                    </p>
                    <p>
                      {{ facePageItem.departmentName
                      }}<el-button
                        class="fr"
                        @click="personImgShow(facePageItem)"
                        type="primary"
                        size="mini"
                        >详情</el-button
                      >
                    </p>

                    <p>{{ facePageItem.personCompany }}</p> -->
                    <p>{{ facePageItem.name || "无" }}</p>
                    <p>
                      <span v-if="facePageItem.passType == 0">重点人员</span>
                      <span v-if="facePageItem.passType == 1"
                        >企业通行人员</span
                      >
                      <span v-if="facePageItem.passType == 2"
                        >临时通行人员</span
                      >
                      <!-- {{ facePageItem.passType
                      }} --><el-button
                        class="fr"
                        @click="personImgShow(facePageItem)"
                        type="primary"
                        size="mini"
                        >详情</el-button
                      >
                    </p>
                    <p>{{ facePageItem.passingTimeFormat.replace("T"," ") }}</p>
                    <el-tooltip
                      :disabled="facePageItem.deviceName.length < 14"
                      :content="facePageItem.deviceName"
                      placement="top"
                      effect="light"
                    >
                      <a
                        href="javascript:;"
                        style="width: 100%"
                        class="text_overflow"
                        >{{ facePageItem.deviceName }}</a
                      >
                    </el-tooltip>
                  </div>
                </div>

                <div style="clear: both"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 顶部中间统计数量 -->
        <div class="center-div">
          <div class="center-top-div">
            <div style="flex: 1; display: flex">
              <div
                v-for="(item, key) in saveCountList"
                :key="key"
                class="middle-small-div"
              >
                <div class="middle-titile">{{ item.name }}</div>
                <div style="display: flex; font-size: 14px; text-align: center">
                  <div style="flex: 1" class="u-color-c1">待审核:</div>
                  <div style="flex: 1" class="u-color-c1">已审核:</div>
                </div>
                <div style="display: flex; font-size: 14px; text-align: center">
                  <div style="flex: 1">
                    <a
                      href="javascript:;"
                      @click="$router.push(item.hash1)"
                      style="color: #ea3232"
                      >{{ item.notAproval }}</a
                    >
                  </div>
                  <div style="flex: 1">
                    <a
                      href="javascript:;"
                      @click="$router.push(item.hash2)"
                      style="color: #33e955"
                      >{{ item.approval || item.aproval }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="map-div">
            <div id="container" style="height: 100%"></div>
            <div class="control-region-legend">
              <div
                v-for="item in controlRegionLegend"
                :key="item.level"
                class="control-region-legend__item"
              >
                <span :style="{ background: item.color }"></span>{{ item.label }}
              </div>
            </div>
          </div>

          <!-- 底部公告 -->
          <div class="middle-bottom-div" @click="showNoticeList">
            <div>
              <Marquee class="realData">
                <ul class="scroll-cont">
                  <span v-for="(item5, key5) in hyNoticeList" :key="key5"
                    ><span v-if="item5.statusName == 1">{{
                      `[${item5.title}] ${item5.content}`
                    }}</span></span
                  >
                </ul>
              </Marquee>
            </div>
          </div>
        </div>
        <div class="right-div">
          <div class="right-top1-div">
            <div class="title">
              <i class="el-icon el-icon-s-marketing"></i>今日流量
            </div>
            <div class="top-num-one">
              <div class="num-title">人流量</div>
              <div style="flex: 1; display: flex">
                <div
                  v-for="(item, index) in todayFlow.personCount"
                  :key="index"
                  style="width: 14%; padding: 0 1.5%"
                >
                  <div class="num-div">{{ item }}</div>
                </div>
              </div>
            </div>
            <div class="top-num-one">
              <div class="num-title">车流量</div>
              <div style="flex: 1; display: flex">
                <div
                  v-for="(item2, index2) in todayFlow.carCount"
                  :key="index2"
                  style="width: 14%; padding: 0 1.5%"
                >
                  <div class="num-div">{{ item2 }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右边摄像头点位 -->
          <div v-if="roleType == 1" class="right-top2-div">
            <div class="title">
              <i class="iconfont icon-dianweitip"></i>摄像头快捷点位
              <span
                class="fr"
                style="padding-right: 14px; cursor: pointer"
                @click="goSsjk('/mngm-ssjk')"
                >更多>></span
              >
            </div>
            <div class="camera-div">
              <div
                class="camera-list"
                v-for="(item4, key4) in deviceList"
                :key="key4"
              >
                <div @click="getVideo(item4)">
                  <el-tooltip
                    :disabled="item4.name.length < 10"
                    :content="item4.name"
                    placement="top"
                    effect="light"
                  >
                    <a
                      href="javascript:;"
                      style="width: 86%"
                      class="text_overflow"
                      @click="getChannelid(item4.deviceId, 1)"
                      >{{ item4.name || "视频点位视频点位视频" }}</a
                    >
                  </el-tooltip>
                  <span
                    class="circle"
                    :class="['circle-status-' + item4.onLine]"
                  ></span>
                </div>
              </div>
            </div>
          </div>

          <!-- 右边摄像播放框 -->
          <div v-if="roleType == 1" class="right-middle-div">
            <div class="title">
              <i class="iconfont icon-dianweitip"></i>{{ camera.title }}
            </div>
            <div
              style="padding: 4px; text-align: center; flex: 1"
              :key="refreKey"
            >
              <!-- <video-ws-stream
                v-if="camera.streamUrl || tempOpen"
                :data="camera"
              ></video-ws-stream> -->
              <assembly-flv
                v-if="camera.streamUrl"
                :url="camera.streamUrl"
                style="width: 100%;"
              ></assembly-flv>
              <div v-else style="padding-top: 16%">暂无视频</div>
            </div>
          </div>

          <!-- 右下角资料框 -->
          <div class="right-bottom-div">
            <div class="title">
              <i class="iconfont icon-wenjianziliao"></i>资料信息
              <span
                class="fr"
                @click="goSsjk('/xtgl-zlkgl')"
                style="padding-right: 14px; cursor: pointer"
                v-if="roleType == 1"
                >更多>></span
              >
            </div>
            <div style="text-align: center; flex: 1; width: 100%; padding: 6px">
              <div>
                <div
                  style="
                    display: flex;
                    background: #0c375a;
                    height: 40px;
                    line-height: 40px;
                  "
                >
                  <div style="width: 40%">文件名称</div>
                  <div style="width: 20%">下载次数</div>
                  <div style="width: 40%">上传日期</div>
                </div>
                <div>
                  <div
                    class="table-body"
                    style="display: flex"
                    v-for="(item, index) in config.data"
                    :key="index"
                  >
                    <div style="width: 40%">
                      <el-tooltip
                        :disabled="item.filename.length < 10"
                        :content="item.filename"
                        placement="top"
                        effect="light"
                        ><span style="width: 100%" class="text_overflow">{{
                          item.filename
                        }}</span></el-tooltip
                      >
                    </div>
                    <div style="width: 20%">{{ item.downloadcount }}</div>
                    <div style="width: 40%">
                      <el-tooltip
                        :disabled="false"
                        :content="item.uploadtime"
                        placement="top"
                        effect="light"
                        ><span style="width: 100%" class="text_overflow">{{
                          item.uploadtime
                        }}</span></el-tooltip
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!-- <dv-scroll-board
                :key="refreshScrollKey"
                :config="config"
                @mouseover="showConfig"
                style="width: 380px; height: 100%"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- class="is-dark" 是黑色框 -->
    <div
      v-show="tipShow"
      class="el-tooltip__popper is-light"
      x-placement="top"
      :style="tipObj"
      @mouseenter="tipShow = false"
    >
      {{ tipMsg }}
      <div x-arrow="" class="popper__arrow" style="left: 76px"></div>
    </div>

    <el-dialog
      title="公告"
      :visible.sync="showNotice"
      width="50%"
      custom-class="zlkgl"
      :close-on-click-modal="false"
    >
      <el-form :model="hyNoticeList">
        <el-form-item label="">
          <span v-for="(item5, key5) in hyNoticeList" :key="key5" >
            <span v-if="item5.statusName == 1" style="color: white;">
              <b>公告标题：{{`[${item5.title}]`}}</b>
              <br>
              公告内容：{{`${item5.content}`}}<br><br><br>
            </span>
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Mixin from "./mixin.js";
import config from "@/web.config.js";
import videoWsStream from "@/components/video-ws-stream.vue";
import assemblyFlv from "@/components/assembly-flv.vue";
export default {
  name: "topnav",
  mixins: [Mixin],
  data() {
    const typeTime = {
      beginTime: this.$myPlug.timeFormat(
        new Date().getTime() - 60000 * 60 * 24 * 30,
        "yyyy-mm-dd hh:MM:ss"
      ),
      endTime: this.$myPlug.timeFormat(
        new Date().getTime(),
        "yyyy-mm-dd hh:MM:ss"
      )
    };
    return {
      roleType: JSON.parse(localStorage.getItem("userInfo")).roleType,
      userId: JSON.parse(localStorage.getItem('userInfo')).user_id,
      userIds: [421,1419,3736,4881,6985,7704,11231,22714,44552],
      carMoveOpen:false,
      tempOpen: config.tempOpen,
      baseUrl: config.cameraUrl,
      todayFlow: {},
      map: null,
      videosrc: "",
      infoWindowloading: false,
      mapMarkerData: [],
      controlRegionList: [],
      controlRegionPolygons: [],
      controlRegionLegend: [
        { level: 1, label: "一级管控", color: "#ff3b30" },
        { level: 2, label: "二级管控", color: "#ff9500" },
        { level: 3, label: "三级管控", color: "#b00020" }
      ],
      infoWindow: null,
      infoWindowContent: {},
      videoShow: false,
      tipShow: false,
      showNotice: false,
      refreKey: "t",
      streamUrl: "",
      tipMsg: "",
      camera: {
        title: "实时监控",
        streamUrl: "",
        channelId: ""
      },
      streamRequestSeq: 0,
      company: [],
      queryParam: {
        pageIndex: 1,
        pageRow: 1000
      },
      tipObj: {},
      form: {},
      saveTimer1: null,
      saveTimer2: null,
      saveTimer: null,
      saveTimer60: null,
      saveCountList: [
        {
          name: "企业通行车辆",
          notAproval: 0,
          aproval: 0,
          hash: "/",
          //hash1 : {path: '/sbgl-sbclsp',name:'217',params:{declareType:1,checkStatus:0}},
          //hash2 : {path: '/sbgl-sbclsp',name:'217',params:{declareType:1,checkStatus:3}}
          hash1: [],
          hash2: []
        },
        {
          name: "临时通行车辆",
          notAproval: 0,
          aproval: 0,
          hash: "/",
          // hash1 : {path: '/sbgl-sbclsp',name:'217',params:{declareType:2,checkStatus:0}},
          // hash2 : {path: '/sbgl-sbclsp',name:'217',params:{declareType:2,checkStatus:3}}
          hash1: [],
          hash2: []
        },
        {
          name: "危化品车",
          notAproval: 0,
          aproval: 0,
          hash: "/",
          // hash1 : {path: '/sbgl-sbclsp',name:'217',params:{vehicleType:4,checkStatus:0}},
          // hash2 : {path: '/sbgl-sbclsp',name:'217',params:{vehicleType:4,checkStatus:3}}
          hash1: [],
          hash2: []
        },
        {
          name: "企业通行人员",
          notAproval: 0,
          aproval: 0,
          hash: "/",
          // hash1 : {path: '/sbgl-sbrysp',name:'218',params:{declareType:1,checkStatus:0}},
          // hash2 : {path: '/sbgl-sbrysp',name:'218',params:{declareType:1,checkStatus:3}}
          hash1: [],
          hash2: []
        },
        {
          name: "临时通行人员",
          notAproval: 0,
          aproval: 0,
          hash: "/",
          // hash1 : {path: '/sbgl-sbrysp',name:'218',params:{declareType:2,checkStatus:0}},
          // hash2 : {path: '/sbgl-sbrysp',name:'218',params:{declareType:2,checkStatus:3}}
          hash1: [],
          hash2: []
        }
      ],
      loading: false,
      refreshScrollKey: "t1",
      warningInfoList: [],
      hyNoticeList: [],
      facePageList: [],
      initFileList: "", //用于保存未处理前的后端数据，定时跟新前要作对比，不是一样的才刷新列表
      init_warningInfoList: "",
      init_hyNoticeList: "",
      initMotorvehicleList: "",
      init_facePageList: "",
      initMotorvehicleList: [], //用于保存未处理前的后端数据，定时跟新前要作对比，不是一样的才刷新列表
      deviceList: [],
      motorvehicleList: [],
      hyNoticeForm: {},
      facePageForm: {},
      motorvehicleForm: {
        pageIndex: 1,
        pageRow: 10
      },
      warningInfoForm: {},
      fileListForm: {},
      deviceListForm: {
        deviceType: "4"
      },
      tabList: ["车辆信息", "人员信息"],
      tabscurrent: 0,
      config: {
        header: ["文件名称", "下载次数", "上传日期"],
        data: [
          // ['行1列1', '行1列2', '行1列3'],
        ],
        columnWidth: [150, 100, 180],
        align: ["center", "center", "center"]
      }
    };
  },
  // 注册组件
  components: {
    videoWsStream,
    "assembly-flv": assemblyFlv
  },
  methods: {
    setBig(src) {
      this.$store.commit("set_dbClickImg", src);
    },
    mousemove(event) {
      var e = event ? event : window.event;
      var x = e.clientX;
      var y = e.clientY;
      var obj = document.elementFromPoint(x, y);
      return {
        X: obj.getBoundingClientRect().left,
        Y: obj.getBoundingClientRect().top
      };
    },
    showConfig(obj) {
      this.tipShow = false;
      if (!obj || !obj.ceil || obj.ceil.length < 7 || obj.columnIndex != 0)
        return;
      this.tipMsg = obj.ceil;
      const cleint = this.mousemove();
      this.tipObj = {
        top: cleint.Y - 36 + "px",
        left: cleint.X + "px"
      };
      if (this.saveTimer1) {
        clearTimeout(this.saveTimer1);
        this.saveTimer1 = null;
      }
      this.saveTimer1 = setTimeout(() => {
        this.tipShow = true;
      }, 500);
      if (this.saveTimer2) {
        clearTimeout(this.saveTimer2);
        this.saveTimer2 = null;
      }
      this.saveTimer2 = setTimeout(() => {
        this.tipShow = false;
      }, 3500);
    },
    getVideo(info) {
      /* console.log(info);
      if (process.env.NODE_ENV === "production") {
        this.$http
          .GET_wsAddress({
            params: {
              paramsID: info.deviceID,
            },
          })
          .then((res) => {});
      } else {
        this.$axios("-camera/domeCamera/getWsAddress/88").then((res) => {
          if (res.data) {
            this.camera = res.data;
            this.camera.title = info.deviceName;
            this.refreKey = "c" + new Date().getTime();
          }
        });
      } */
    },
    onSubmit(form) {
      if (form == 1 || form == "clearplate") {
        if (form == "clearplate") this.form.plateNo = "";
        this.motorvehicleForm.pageIndex = 1;
        this.loading = true;
        // this.motorvehicleForm.vehicleColor = this.form.vehicleColor;
        this.motorvehicleForm.plateNo = this.form.plateNo;
        this.getMotorvehicleList();
      } else if (form == 2 || form == "clearname") {
        if (form == "clearname") this.form.name = "";
        this.loading = true;
        this.facePageForm.name = this.form.name;
        this.getFaceList();
      }
    },
    goSsjk(router) {
      const documentTitle_menuName = {};
      if (router == "/mngm-ssjk") {
        this.$store.commit("topnav_activeNav1", 3);
        documentTitle_menuName.mngmSsjk = "实时监控";
      } else {
        this.$store.commit("topnav_activeNav1", 6);
        documentTitle_menuName.xtglZlkgl = "资料库管理";
      }
      this.$store.commit("documentTitle_menuName", documentTitle_menuName);
      this.$router.push(router);
    },
    carimgShow(data) {
      data.img = data.thumbnailUrl || "/static/img/img_error2.png";
      this.$store.commit("boxDetail", {
        carList_format: data,
        showCard: ["过车信息", "数据信息"],
        title: "详情"
      });
    },
    personImgShow(data) {
      data.img = data.storageUrl1 || "/static/img/img_error2.png";
      this.$store.commit("boxDetail", {
        oneCardInfo: data,
        title: "详情"
      });
    },
    setIndex(val) {
      this.tabscurrent = val;
    },
    getIndexCheckStatus(data) {
      const resData =data
	  console.log(5111111111);
	  console.log(resData);
        if (resData != null && resData != "") {
          this.saveCountList = [];
		  console.log(52222222);
          resData.forEach(item => {
            let hash1 = "";
            let hash2 = "";
            if (item.name.indexOf("企业通行车辆") > -1) {
              hash1 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { declareType: 1, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { declareType: 1, checkStatus: 3 }
              };
            } else if (item.name.indexOf("临时通行车辆") > -1) {
              hash1 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { declareType: 2, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { declareType: 2, checkStatus: 3 }
              };
            } else if (item.name.indexOf("通勤通行车辆") > -1) {
              hash1 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { declareType: 3, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { declareType: 3, checkStatus: 3 }
              };
            } else if (item.name.indexOf("企业通行人员") > -1) {
              hash1 = {
                path: "/sbgl-sbrysp",
                name: "218",
                params: { declareType: 1, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbrysp",
                name: "218",
                params: { declareType: 1, checkStatus: 3 }
              };
            } else if (item.name.indexOf("临时通行人员") > -1) {
              hash1 = {
                path: "/sbgl-sbrysp",
                name: "218",
                params: { declareType: 2, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbrysp",
                name: "218",
                params: { declareType: 2, checkStatus: 3 }
              };
            } else if (item.name.indexOf("通勤通行人员") > -1) {
              hash1 = {
                path: "/sbgl-sbrysp",
                name: "218",
                params: { declareType: 3, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbrysp",
                name: "218",
                params: { declareType: 3, checkStatus: 3 }
              };
            } else {
              hash1 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { vehicleType: 4, checkStatus: 0 }
              };
              hash2 = {
                path: "/sbgl-sbclsp",
                name: "217",
                params: { vehicleType: 4, checkStatus: 3 }
              };
            }

            this.saveCountList.push({
              name: item.name,
              notAproval: item.notAproval,
              approval: item.approval,
              aproval: item.aproval,
              hash1,
              hash2
            });
			console.log(61111111);
			console.log(this.saveCountList);
          });
        }

    },
    getHyNotice() {
      this.hyNoticeForm.pageIndex = 1;
      this.hyNoticeForm.pageRow = 10;

      this.$http.POST_hyNotice(this.hyNoticeForm).then(res => {
        if (res.data) {
          this.hyNoticeList = res.data.records;
        }
      });
    },
    showNoticeList(){
      this.showNotice = true;
    },
    getWarningInfo(data) {
      this.warningInfoForm.pageIndex = 1;
      this.warningInfoForm.pageRow = 10;

      if (data&&data.length) {
        let preList = "";

        data.forEach(item => {
          preList += item.notificationID + ",";
        });
        if (this.init_warningInfoList != preList) {
          this.init_warningInfoList = "";
          data.forEach(item => {
            this.init_warningInfoList += item.notificationID + ",";
          });
          this.warningInfoList = data;
        }
      }
    },
    handleFaceList(resData){
      if(resData&&resData.length){
		if (this.roleType != 3) {
          let preList = "";
          resData.forEach(item => {
            preList += item.faceID + ",";
          });
          if (this.init_facePageList != preList) {
            this.init_facePageList = "";
            resData.forEach(item => {
              this.init_facePageList += item.faceID + ",";
            });
            this.facePageList = resData;
          }
        }
      }
    },
    getFaceList() {
      if (this.roleType != 3) {
        this.facePageForm.pageIndex = 1;
        this.facePageForm.pageRow = 10;

        this.$http.POST_facePage(this.facePageForm).then(res => {
          if (res.data) this.handleFaceList(res.data);
        });
      }
    },
    handleMotorvehicleList(resData){
        if (this.roleType != 3) {
        if(resData&&resData.length){
         let preList = "";

          resData.forEach(item => {
            preList += item.plateNo + item.passingTime + ",";
          });
          if (this.initMotorvehicleList != preList) {
            this.initMotorvehicleList = "";
            resData.forEach(item => {
              this.initMotorvehicleList +=
                item.plateNo + item.passingTime + ",";
            });
            this.motorvehicleList = [];
            for (var i = 0; i < resData.length; i++) {
              const result = this.$myPlug.sortName2cn(resData[i]);
              result.passingTimeFormat = result.passingTimeFormat.replace("T"," ");
              this.motorvehicleList.push(result);
            }
          }
        }
       }
    },
    getMotorvehicleList(data) {
      if (this.roleType != 3) {

        this.$http
          .POST_motorvehiclePage(this.motorvehicleForm)
          .then(res => {

            if (res.data) this.handleMotorvehicleList(res.data);
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      }
    },
    getFileList() {
      this.fileListForm.pageIndex = 1;
      this.fileListForm.pageRow = 10;
      this.$http.POST_fileList(this.fileListForm).then(res => {
        if (res.data) {
          this.config.data = [];
          res.data.forEach(params => {
            this.config.data.push({
              filename: params.filename,
              downloadcount: params.downloadcount,
              uploadtime: params.uploadtime
            });
          });
          console.log(this.config.data);
          this.refreshScrollKey = "t" + new Date().getTime();
        }
      });
    },
    getDeviceList() {
      this.deviceListForm.pageIndex = 1;
      this.deviceListForm.page = 1;
      this.deviceListForm.pageRow = 10;
      this.deviceListForm.limit = 10;
      // this.$http.POST_deviceList(this.deviceListForm).then((res) => {
      //   if (res.data) this.deviceList = res.data;
      // });
      if (this.roleType == 1) {
        this.$axios({
          method: "get",
          url:
            this.baseUrl+"/api/device/query/devices?page=" +
            this.deviceListForm.page +
            "&count=10",
          timeout: 30000
        }).then(res => {
          if (res.data) {
            for (var i = 0; i < res.data.list.length; i++) {
              if (
                res.data.list[i].name == null ||
                res.data.list[i].name == ""
              ) {
                res.data.list[i].name = "未命名设备";
              }
            }
            this.deviceList = res.data.list;
            this.getChannelid(res.data.list[0].deviceId, 1);
          }
        });
      }
    },
    getChannelid(deviceId, type) {
      const requestId = this.streamRequestSeq + 1;
      this.streamRequestSeq = requestId;
      this.$axios({
        method: "get",
        // url: this.baseUrl+"/api/device/query/tree/channel/" + deviceId + "?page=1&count=1",
        url: this.baseUrl+"/api/device/query/devices/"+deviceId+"/channels?page=1&count=1",
        timeout: 30000
      }).then(res => {
        if (requestId !== this.streamRequestSeq) {
          return;
        }
        this.camera.channelId = res.data.list[0].deviceId;
        this.camera.deviceId = deviceId;
        this.openVideo(type, requestId);
      });
    },
    replaceDomain(str){
      return str.indexOf('39.184.153.92')!=-1?str.replace('39.184.153.92','huagongyq.dingpod.cn'):str;
    },
    openVideo(type, requestId) {
      const activeRequestId = requestId === undefined ? this.streamRequestSeq + 1 : requestId;
      this.streamRequestSeq = activeRequestId;
      const deviceId = this.camera.deviceId;
      const channelId = this.camera.channelId;
      if (type == 1) this.camera.streamUrl = "";
      this.$axios({
        method: "get",
        url:
          this.baseUrl+"/api/play/start/" + this.camera.deviceId + "/" + this.camera.channelId,
        //headers:this.headers,
        timeout: 30000
      }).then(res => {
        if (activeRequestId !== this.streamRequestSeq
            || deviceId !== this.camera.deviceId
            || channelId !== this.camera.channelId) {
          return;
        }
        if (res.code == 0) {
          if (type == 1) {
            this.camera.streamUrl = this.replaceDomain(res.data.https_flv);
          } else {
            this.videosrc = this.replaceDomain(res.data.https_flv);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    setCompany() {
      //this.$http[this.apiUrl.Enterpriseinfo](this.queryParam).then(response => {
      this.$http.POST_hyEnterpriseIndex(this.queryParam).then(res => {
        if (res.code == "00000") {
		  res.data.forEach((element, key) => {
		      this.company.push({
		        lable: element.coName,
		        value: element.id
		      });
		    });
		    localStorage.setItem("company", JSON.stringify(this.company));
        }
      });
    },
    initmap() {
      this.map = new AMap.Map("container", {
        viewMode: "2D", // 默认使用 2D 模式，如果希望使用带有俯仰角的 3D 模式，请设置 viewMode: '3D',
        zoom: 15, //初始化地图层级
        center: [121.036545, 30.599264], //初始化地图中心点
        // mapStyle: "amap://styles/f0dd592dc487b7a45389444170186215"
        mapStyle: "amap://styles/8e9dc097afd432a386f14670244eca1c",
        // mapStyle: 'amap://styles/dark'
      });
    },
    getMapData() {
      this.$axios({
        method: "GET",
        url: "/dqi-hymanage/device/getEnableDevice"
      }).then(res => {
        this.mapMarkerData = res.data;
        this.drawMarker();
      });

      this.userIds.forEach(element => {
          if(this.userId == element){
            this.carMoveOpen = true
        }
      });
    },
    getControlRegionList() {
      this.$http.GET_controlRegionEnableList().then(res => {
        this.controlRegionList = res.data || [];
        this.drawControlRegions();
      });
    },
    drawControlRegions() {
      if (!this.map) {
        return;
      }
      if (this.controlRegionPolygons.length) {
        this.controlRegionPolygons.forEach(polygon => {
          this.map.remove(polygon);
        });
      }
      this.controlRegionPolygons = [];
      this.controlRegionList.forEach(item => {
        const path = this.parseControlRegionPath(item.polygonPath);
        if (path.length < 3) {
          return;
        }
        const polygon = new AMap.Polygon(Object.assign({
          path
        }, this.getControlRegionStyle(item.controlLevel)));
        polygon.on("click", () => {
          this.$message.info(`${item.regionName || ""} ${this.getControlRegionLevelName(item.controlLevel)}`);
        });
        this.map.add(polygon);
        this.controlRegionPolygons.push(polygon);
      });
    },
    parseControlRegionPath(value) {
      if (!value) {
        return [];
      }
      try {
        const raw = JSON.parse(value);
        if (!Array.isArray(raw)) {
          return [];
        }
        return raw.map(item => {
          if (Array.isArray(item)) {
            return [Number(item[0]), Number(item[1])];
          }
          return [Number(item.lng || item.longitude), Number(item.lat || item.latitude)];
        }).filter(item => !isNaN(item[0]) && !isNaN(item[1]));
      } catch (e) {
        return [];
      }
    },
    getControlRegionStyle(level) {
      const styleMap = {
        1: { strokeColor: "#ff3b30", fillColor: "#ff3b30" },
        2: { strokeColor: "#ff9500", fillColor: "#ff9500" },
        3: { strokeColor: "#b00020", fillColor: "#b00020" }
      };
      const style = styleMap[level] || styleMap[1];
      return Object.assign({
        strokeWeight: 2,
        strokeOpacity: 0.95,
        fillOpacity: 0.26,
        zIndex: 10
      }, style);
    },
    getControlRegionLevelName(level) {
      const map = {
        1: "一级管控",
        2: "二级管控",
        3: "三级管控"
      };
      return map[level] || "";
    },
    drawMarker() {
      this.mapMarkerData.forEach((item, index) => {
        let markerSrc = "";
        if (item.deviceType == "1") {
          markerSrc = "/static/img/map-icon/camera.png";
        } else if (item.deviceType == "2") {
          markerSrc = "/static/img/map-icon/zhaji.png";
        } else if (item.deviceType == "3") {
          markerSrc = "/static/img/map-icon/renlian.png";
        } else if (item.deviceType == "4") {
          markerSrc = "/static/img/map-icon/qiu.png";
        }
        let marker = new AMap.Marker({
          map: this.map,
          icon: markerSrc,
          position: [item.longitude, item.latitude],
          offset: new AMap.Pixel(-13, -40)
        });
        if (this.roleType == 1)
          marker.on("click", () => {
            this.markerClick(item);
          });
      });
    },
    markerClick(marker) {
      this.videoShow = false;
      this.infoWindowloading = true;
      this.infoWindowContent = {};
      console.log('点击点标记1',marker.deviceType)
      if (marker.deviceType == "4") {
        this.videoShow = true;
        this.videosrc = "";
        console.log('点击点标记2',marker.deviceID)
        this.getChannelid(marker.deviceID, 2);
        console.log('点击点标记3',marker.deviceID)
      } else {
        console.log('点击点标记4',marker.deviceType)
        let url = "";
        if (
          marker.deviceType == "1" ||
          marker.deviceType == "2" ||
          marker.deviceType == "抓拍相机" ||
          marker.deviceType == "车辆闸机"
        ) {
          url = "/dqi-hymanage/motorvehicle/page";
        } else if (marker.deviceType == "3" || marker.sex) {
          url = "/dqi-hymanage/face/page";
        }
        const data = {
          pageIndex: "1",
          pageRow: "1",
          deviceID: marker.deviceID
        };
        console.log('点击点标记5',marker.deviceType)
        try{
          this.$axios({
            method: "POST",
            data: data,
            url: url
          }).then(res => {
            console.log('点击点标记6',marker.deviceType)
            this.infoWindowloading = false;
            if (res.data.length > 0) {
              this.infoWindowContent = res.data[0]; //只显示最新一条
            } else {
              this.infoWindowContent = {};
            }
          });
        }catch (err){
          console.log('请求报错',err)
          this.infoWindowContent = {};
        }
      }
      const HTML = this.$refs.Popup;
      console.log('点击点标记7',marker.deviceType)
      this.infoWindow = new AMap.InfoWindow({
        content: HTML,
        autoMove: true,
        retainWhenClose: true,
        position: [marker.longitude, marker.latitude],
        closeWhenClickMap: true, // 点击全屏地图关闭信息窗口
        offset: new AMap.Pixel(0, -40)
      });
      console.log('点击点标记8',marker.deviceType)
      this.infoWindow.open(this.map);
    },
    GET_todayFlow(resData) {
      if(resData.carCount){
        let carCount = resData.carCount + 10000000;
          carCount = carCount.toString().slice(1);
          let personCount = resData.personCount + 10000000;
          personCount = personCount.toString().slice(1);
          this.todayFlow = {
            carCount,
            personCount
          };
      }
    },
    getSomeList(data={}) {
      this.getIndexCheckStatus(data.indexCheckStatus);  // 获取中间审核，对不上旧版
      this.getWarningInfo(data.hyNotificationPage);  // 获取预警布控
      setTimeout(() => {
        this.handleMotorvehicleList(data.motorvehicPage);  // 获取车辆检索
        if(data.facePage)this.handleFaceList(data.facePage);  // 获取人脸检索
      }, 500);
      setTimeout(() => {
        this.initChart(data.indexCarAndPersonFlow);  // 获取echart图表数据
        this.GET_todayFlow(data.indexTodayFlow);  // 获取今日流量
      }, 800);
      setTimeout(() => {
        if(this.carMoveOpen){
          this.handleDrawData(data.carTrackMulti) // 地图汽车
          console.log("授权用户才会执行车辆轨迹")
        }
      }, 1500);
    },
    getAllLoopData() {
      this.$http.GET_getAllResource().then(res => {
        console.log(res);
        if (res.data) {
          this.getSomeList(res.data)
        }
      });
    }
  },
  mounted() {
    this.initmap();
    this.getControlRegionList();
    this.getMapData();
  },
  created() {
	 //  setTimeout(()=>{
	 //  	// this.getDrawData() // 单个测试地图小车
		// // this.getMotorvehicleList() // 单个测试左下角车辆检索列表
		// this.getFaceList()  // 单个测试左下角人脸检索列表
	 //  	},2000)
	// return
	// -----------上面临时测试用


    this.getDeviceList();  // 获取地图卡口砸机
    this.getHyNotice();  // 获取底部公告
    this.getFileList();  // 获取资料
	this.setCompany();  // 获取企业列表
    this.getAllLoopData()
    this.saveTimer = setInterval(() => {
      this.getAllLoopData()
    }, 30000);
    this.saveTimer60 = setInterval(() => {
      this.getHyNotice();
    }, 180000);
  },
  destroyed() {
    clearInterval(this.saveTimer);
    clearInterval(this.saveTimer60);
  }
};
</script>
<style lang="scss">
.text_overflow {
  color: #fff;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.marker-content-div {
  color: #222;
  padding: 10px;
  line-height: 26px;
}
input::-webkit-input-placeholder {
  font-size: 14px;
}
.el-form-item__label {
  font-size: 14px;
  color: #fff;
}
.el-input__inner {
  font-size: 14px;
}
.map {
  height: 100vh;
  width: 100%;
}
.h-div-content {
  font-size: 14px;
  color: #fff;
  .title {
    height: 46px;
    line-height: 46px;
    padding-left: 10px;
    font-size: 16px;
    background: url(../../../static/img/home_title_bg.png) no-repeat;
    background-size: 100% 100%;
    .el-icon,
    .iconfont {
      padding-right: 10px;
    }
    .el-icon {
      font-size: 18px;
    }
  }
  .d-tabs {
    padding-left: 15px;
    .active {
      border-bottom: 3px#ffc107 solid;
      color: #ffc107;
    }
    span {
      padding: 0 5px;
      display: inline-block;
      height: 100%;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
.main-div {
  width: 100%;
  position: absolute;
  top: 0.8rem;
  bottom: 0;
  left: 0;
  right: 0;
  .left-div {
    display: flex;
    flex-direction: column;
    // background: #eee;
    width: 22%;
    height: 100%;
    .content-list {
      flex: 1;
      padding: 0 10px;
      padding-bottom: 10px;
      line-height: 20px;
      overflow: auto;
      .list {
        border-bottom: 1px #016ae0 dashed;
        padding: 8px 0;
      }
    }
    /* .left-top-div {
      width: 100%;
      height: 0%;

      border-radius: 6px;
      margin-bottom: 6px;
      display: flex;
      flex-direction: column;
    } */
    .left-center-div {
      width: 100%;
      height: 39%;

      border-radius: 6px;
      margin-bottom: 6px;
      display: flex;
      flex-direction: column;
      padding-top: 6px;
      #my-chart {
        width: 100%;
        height: 98%;
      }
    }
    .left-bottom-div {
      width: 100%;
      height: 60%;
      display: flex;
      flex-direction: column;

      border-radius: 6px;
    }
  }
}

.center-div {
  width: 56%;
  padding: 6px;
  display: flex;
  flex-direction: column;
  .center-top-div {
    height: 78px;

    border-radius: 6px;
    display: flex;
    margin-bottom: 6px;
    .middle-small-div {
      flex: 1;
      padding: 10px;
      color: #fff;
      .middle-titile {
        text-align: center;
        font-size: 16px;
      }
    }
  }
  .map-div {
    width: 100%;
    flex: 1;
    position: relative;
    // border: 1px #4479b1 solid;
    border-radius: 6px;
    margin-bottom: 6px;
  }
  .control-region-legend {
    position: absolute;
    right: 12px;
    bottom: 12px;
    z-index: 10;
    padding: 8px 10px;
    color: #fff;
    background: rgba(3, 24, 49, 0.72);
    border: 1px solid rgba(53, 189, 219, 0.35);
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
    pointer-events: none;
  }
  .control-region-legend__item {
    white-space: nowrap;
    span {
      display: inline-block;
      width: 12px;
      height: 8px;
      margin-right: 6px;
      border: 1px solid rgba(255, 255, 255, 0.45);
    }
  }
  .middle-bottom-div {
    width: 100%;
    border: 1px #2b527c solid;
    // border-radius: 6px;
    padding: 0 10px;
    .realData {
      height: 30px;
      line-height: 30px;
    }
    span {
      padding-right: 60px;
    }
  }
}

.right-div {
  height: 100%;
  display: flex;
  flex-direction: column;
  // background: #eee;
  width: 22%;
  .right-top1-div {
    height: 160px;
    margin-bottom: 6px;

    border-radius: 6px;
    .top-num-one {
      padding-left: 10px;
      padding-top: 16px;
      display: flex;
      width: 100%;
      height: 32%;
      .num-div {
        width: 100%;
        height: 42px;
        text-align: center;
        line-height: 40px;
        font-size: 20px;
        border: 2px transparent solid;
        border-image: linear-gradient(to bottom, #29bef5, #0169ca) 1 10;
      }
      .num-title {
        height: 36%;
        line-height: 40px;
        padding-right: 6px;
      }
    }
  }
  .right-top2-div {
    width: 100%;
    flex: 1;
    margin-bottom: 6px;

    border-radius: 6px;
    display: flex;
    flex-direction: column;
    padding-bottom: 4px;
    .camera-div {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      overflow: auto;
      .camera-list {
        width: 50%;
        padding: 2px;

        > div {
          border: 2px solid #016ae0;
          border-radius: 4px;
          height: 32px;
          padding-left: 6px;
          line-height: 32px;

          .circle {
            vertical-align: middle;
            margin-left: 4px;
            display: inline-block;
            width: 4px;
            height: 4px;
            margin-top: -30px;
            border-radius: 50%;
            animation: myfirst 1s infinite;
          }
          .circle-status-false {
            background: rgb(255, 0, 0);
          }
          .circle-status-true {
            background: chartreuse;
          }
          .circle-status-0 {
            background: rgb(255, 0, 0);
          }
          .circle-status-1 {
            background: chartreuse;
          }
          .circle-status-2 {
            background: rgb(236, 252, 19);
          }
          .circle-status-3 {
            background: rgb(255, 0, 0);
          }
          .circle-status-4 {
            background: rgb(233, 233, 233);
          }
          @keyframes myfirst {
            0% {
              opacity: 0.2;
              transform: scale(1);
            }
            100% {
              opacity: 1;
              transform: scale(2);
            }
          }
        }
      }
    }
  }
  .right-middle-div {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 6px;

    border-radius: 6px;
  }
  .right-bottom-div {
    width: 100%;

    overflow: auto;
    display: flex;
    flex-direction: column;

    border-radius: 6px;
    .table-body {
      height: 36px;
      line-height: 36px;
    }
    .table-body:nth-child(2n-1) {
      background: #0c436a;
    }
    .table-body:nth-child(2n) {
      background: #0c375a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/HomePage.vue